/* unplugin-vue-components disabled */import script from "./FileAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./FileAttachment.vue?vue&type=script&setup=true&lang=js"

import "./FileAttachment.vue?vue&type=style&index=0&id=b1311ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1311ca4"]])

export default __exports__